<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 军校招生 -->
    <div class="military_school studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner_tool.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">什么是强基计划？</h6>
            <div class="main_box">
                <p>教育部印发《关于在部分高校开展基础学科招生改革试点工作的意见》，决定自2020年起，在部分高校开展基础学科招生改革试点，也称强基计划。<br/>教育部按照“一校一策”的原则，研究确定强基计划招生高校、专业和规模，在确保公平公正的前提下，积极探索多维度考核评价模式，逐步建立基础学科拔尖创新人才选拔培养的有效机制。</p>
            </div>    
        </div>
        <div class="benefit main">
            <h6 class="main_title">强基计划选拔什么样的学生？</h6>
              <div class="main_box" >
                  <p>强基计划指导思想和原则是服务国家战略，招收一批有志向、有兴趣、有天赋的青年学生进行专门培养，为国家重大战略领域输送后备人才。主要选拔有志于服务国家重大战略需求且综合素质优秀或基础学科拔尖的学生。<br/>以下三类考生均符合选拔要求：</p>
              </div>
            <div class="main_box">
                <p>(1)高考成绩优异；</p>
                <p>(2)科竞赛银牌及以上+高考成绩良好（预计高考分达到所在省份本科一批录取最低控制分数线，合并录取批次省份以各省份划定分数线为准）；</p>
                <p>(3)学科竞赛奖项+高考成绩优秀。</p>
            </div>
        </div>
        <div class="main">
            <h6 class="main_title">强基计划招生专业范围有哪些？</h6>
            <div class="main_box">
                <p>强基计划突出基础学科的支撑引领作用，重点在数学、物理、化学、生物及历史、哲学、古文字学等相关专业招生。</p>
                <p>聚焦高端芯片与软件、智能科技、新材料、先进制造和国家安全等关键领域以及国家人才紧缺的人文社会科学领域。高校会结合自身办学特色，合理安排招生专业，并建立学科专业的动态调整机制，根据新形势要求和招生情况，适时调整强基计划招生专业。</p>
            </div>
        </div>
        <div class="benefit main">
            <h6 class="main_title">强基计划的录取方式有哪些？</h6>
            <div class="main_box">
                <p>(1)高校依据考生的高考成绩、高校综合考核结果及综合素质评价情况等按比例合成考生综合成绩（其中高考成绩所占比例不得低于85%），根据考生填报志愿，按综合成绩由高到低顺序录取。</p>
                <p>(2)由高校制定破格入围高校考核的条件和破格录取的办法、标准，并提前向社会公布，组织相关学科领域专家对考生进行严格考核，达到录取标准的，经高校招生工作领导小组审定，报生源所在地省级高校招生委员会核准后予以破格录取。破格录取考生的高考成绩原则上不得低于各省（区、市）本科一批录取最低控制分数线（合并录取批次省份应单独划定相应分数线）。</p>
            </div>
        </div>
        <div class="benefit main">
            <h6 class="main_title">通过强基计划录取后的培养方式有哪些？</h6>
            <div class="main_box">
                <p>(1)高校对通过强基计划录取的学生单独制定培养方案，采取导师制、小班化等培养模式。</p>
                <p>(2)畅通成长发展通道，对学业优秀的学生，高校可在免试推荐研究生、直博、公派留学、奖学金等方面予以优先安排，探索建立本—硕—博衔接的培养模式。</p>
                <p>(3)吸纳学生参与项目研究，推进科教协同育人，探索建立结合重大科研任务的人才培养机制。</p>
            </div>
        </div>

        <div class="main liucheng">
            <h6 class="main_title">强基计划报考流程<span>(当年日程安排以高校公布的最新消息为准)</span></h6>
            <div class="main_box liucheng">
                <ul>
                    <li>3月底—4月，高校公布招生简章，考生网上报名</li>
                    <li>6月，考生参加统一高考</li>
                    <li>6月25日前，各省（区、市）提供高考成绩</li>
                    <li>6月26日前，高校确定参加考核的考生名单</li>
                    <li>7月4日前，高校组织考核</li>
                    <li>7月5日前，高校折算综合成绩，择优录取</li>
                </ul>
            </div>
        </div>       
        <div class="universities main">
            <h6 class="main_title">强基计划2021年试点高校</h6>
            <ul>
                <li v-for="(item, index) in universities" :key="index" ><span>{{item.school_name}}</span></li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            universities: [
                {school_name:"北京大学",},
                {school_name:"中国人民大学",},
                {school_name:"清华大学",},
                {school_name:"北京航空航天大学",},
                {school_name:"北京理工大学",},
                {school_name:"中国农业大学",},
                {school_name:"北京师范大学",},
                {school_name:"中央民族大学",},
                {school_name:"南开大学",},
                {school_name:"天津大学",},
                {school_name:"大连理工大学",},
                {school_name:"吉林大学",},
                {school_name:"哈尔滨工业大学",},
                {school_name:"复旦大学",},
                {school_name:"同济大学",},
                {school_name:"上海交通大学",},
                {school_name:"华东师范大学",},
                {school_name:"南京大学",},
                {school_name:"东南大学",},
                {school_name:"浙江大学",},
                {school_name:"中国科学技术大学",},
                {school_name:"厦门大学",},
                {school_name:"山东大学",},
                {school_name:"中国海洋大学",},
                {school_name:"武汉大学",},
                {school_name:"华中科技大学",},
                {school_name:"中南大学",},
                {school_name:"中山大学",},
                {school_name:"华南理工大学",},
                {school_name:"四川大学",},
                {school_name:"重庆大学",},
                {school_name:"电子科技大学",},
                {school_name:"西安交通大学",},
                {school_name:"西北工业大学",},
                {school_name:"兰州大学",} ,
                {school_name:"国防科技大学",}                
            ]
        }
    },
    methods: {
        // goUniversity(id) {
        //     var id = id;
        //     let {href}=this.$router.resolve({
        //         path: '/yuanxiaoxiangqing',
        //         name: 'yuanxiaoxiangqing',
        //         query: {
        //             id: id,
        //         }
        //     })
        //     window.open(href, '_blank');
        // }
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    .military_school {
        .liucheng {
            ul {
                display: flex;
                flex-wrap: wrap;
                li {
                    text-align: center;
                    line-height: 50px;
                    /* width: 189px; */
                    height: 50px;
                    
                    /* padding-right: 60px; */
                    background: url(/imgs/wayToStudy/common/icon_liucheng.png) no-repeat right center;
                    margin-right: 20px;
                    padding-right: 53px;
                    background-size: 20px 20px;
                    &:last-child {
                        background: none;
                    }
                }
            }
        }
        .universities  ul {
            overflow: hidden;
            width: 933px;
            li {
                font-size: 14px;
                box-sizing: border-box;
                float: left;
                width: 25%;
                border: 1px solid #eaeaea;
                margin-left: -1px;
                margin-top: -1px;
                min-height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 20px;
                text-align: center;
                cursor:default;
                &:nth-child(4n+1) {
                    margin-left: 0px;
                }
                &:nth-child(-n + 4) {
                    margin-top: 0px;
                }
            }
    }
        
    }
    
</style>